module.exports = __webpack_public_path__ + "Roboto-BoldItalic.woff2";